import type React from 'react'

import type { InputLabelProps as MUIInputLabelProps } from '@mui/material'

import { InputLabelStyled } from './styles'

interface InputLabelProps extends MUIInputLabelProps {
  inline?: boolean
  marginBottom?: number
  id?: string
}

export const Label: React.FC<InputLabelProps> = ({
  htmlFor,
  children,
  inline,
  required,
  className,
  marginBottom,
  id,
}) => (
  <InputLabelStyled
    bottom={marginBottom}
    data-testid="label"
    htmlFor={htmlFor}
    id={id}
    inline={inline ? 1 : 0}
    required={required}
    {...(className && { className })}
  >
    {children}
  </InputLabelStyled>
)
